/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCloudDownload = createReactComponent("outline", "cloud-download", "IconCloudDownload", [["path", { "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4", "key": "svg-0" }], ["path", { "d": "M12 13l0 9", "key": "svg-1" }], ["path", { "d": "M9 19l3 3l3 -3", "key": "svg-2" }]]);

export { IconCloudDownload as default };
//# sourceMappingURL=IconCloudDownload.mjs.map
